// extracted by mini-css-extract-plugin
export default {"Statement":"Statement_Statement__e7yMS"};